import { render, staticRenderFns } from "./building_info.vue?vue&type=template&id=89ff8476&lang=pug&"
import script from "./building_info.vue?vue&type=script&lang=js&"
export * from "./building_info.vue?vue&type=script&lang=js&"
import style0 from "./building_info.vue?vue&type=style&index=0&id=89ff8476&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports